/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_EllipsisInputs */

const en_insert_ellipsis = /** @type {(inputs: Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert ellipsis`)
};

const fr_insert_ellipsis = /** @type {(inputs: Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer des points de suspension`)
};

const de_insert_ellipsis = /** @type {(inputs: Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auslassungspunkte einfügen`)
};

const it_insert_ellipsis = /** @type {(inputs: Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci ellissi`)
};

const ru_insert_ellipsis = /** @type {(inputs: Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить многоточие`)
};

const es_insert_ellipsis = /** @type {(inputs: Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar puntos suspensivos`)
};

const zh_cn2_insert_ellipsis = /** @type {(inputs: Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入省略号`)
};

const ja_insert_ellipsis = /** @type {(inputs: Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`省略記号を挿入`)
};

const hi_insert_ellipsis = /** @type {(inputs: Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एलिप्सिस डालें`)
};

const pt_pt2_insert_ellipsis = /** @type {(inputs: Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir reticências`)
};

/**
* | output |
* | --- |
* | "Insert ellipsis" |
*
* @param {Insert_EllipsisInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_ellipsis = /** @type {((inputs?: Insert_EllipsisInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_EllipsisInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_ellipsis(inputs)
	if (locale === "de") return de_insert_ellipsis(inputs)
	if (locale === "it") return it_insert_ellipsis(inputs)
	if (locale === "ru") return ru_insert_ellipsis(inputs)
	if (locale === "es") return es_insert_ellipsis(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_ellipsis(inputs)
	if (locale === "ja") return ja_insert_ellipsis(inputs)
	if (locale === "hi") return hi_insert_ellipsis(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_ellipsis(inputs)
	return en_insert_ellipsis(inputs)
});